import { addEventListener } from '@datadog/browser-core';
export function onBFCacheRestore(configuration, callback) {
  var _addEventListener = addEventListener(configuration, window, "pageshow" /* DOM_EVENT.PAGE_SHOW */, function (event) {
      if (event.persisted) {
        callback(event);
      }
    }, {
      capture: true
    }),
    stop = _addEventListener.stop;
  return stop;
}